import { Injectable } from '@angular/core';
import { CCAuthorizationAgreementParams, EFTAuthorizationAgreementParams } from '../../../../../../../app/shared/payments/ez-pay-authorization/easy-pay-authorization-agreement.service';
import { PaymentItem } from '../../../../../../billing/payment-preferences/shared/models/payment-item.model';
import { DistributedDocumentsResponseModel } from '../../../../../../shared/payments/ez-pay-authorization/eft-authorization-form/model/distributed-documents-response.model';
import { PaymentFormGroup } from '../../../../../../shared/payments/payment-form-group';
import { SetupPaymentResponse } from '../review/setup-automatic-payments-review.service';

@Injectable()
export class SetupAutomaticPaymentsFlowService {
    setUpAutomaticPaymentsForm: PaymentFormGroup;
    billingAccountHolderName: string;
    amountDue: string;
    currentBillDueDate: Date;
    nextBillDueDate: Date;
    isEligibleForEasyPay: boolean;
    considerThisDisplayable: boolean;
    emailAddress: string;
    selectedPayMethod: PaymentItem;
    billingAccountNumber: string;
    successfullyEnrolled: boolean;
    billedStatus: boolean;
    billingStreetLine1: string;
    billingCity: string;
    billingState: string;
    distributedDocumentsResponseModel: DistributedDocumentsResponseModel;
    authorizationAgreementParams: EFTAuthorizationAgreementParams | CCAuthorizationAgreementParams;
    isLifeOnlyAccount: boolean;
    setupPaymentResponse: SetupPaymentResponse;
    hasVULCreditCardError: boolean;
    paymentPlan: string;
    errorDetails: {
        errorMessage: string;
        errorCode: number;
    };
    wasRecurringAuthorizationFormSuccessfullySaved: boolean;

    save(params: Partial<SetupAutomaticPaymentsFlowService>): void {
        this.setUpAutomaticPaymentsForm = params.setUpAutomaticPaymentsForm || this.setUpAutomaticPaymentsForm;
        this.billingAccountHolderName = params.billingAccountHolderName || this.billingAccountHolderName;
        this.amountDue = params.amountDue || this.amountDue;
        this.currentBillDueDate = params.currentBillDueDate || this.currentBillDueDate;
        this.nextBillDueDate = params.nextBillDueDate || this.nextBillDueDate;
        this.isEligibleForEasyPay = params.isEligibleForEasyPay || this.isEligibleForEasyPay;
        this.considerThisDisplayable = params.isEligibleForEasyPay;
        this.emailAddress = params.emailAddress || this.emailAddress;
        this.selectedPayMethod = params.selectedPayMethod || this.selectedPayMethod;
        this.billingAccountNumber = params.billingAccountNumber || this.billingAccountNumber;

        this.successfullyEnrolled = params.successfullyEnrolled != null ? params.successfullyEnrolled : this.successfullyEnrolled;
        this.billedStatus = params.billedStatus || this.billedStatus;
        this.billingStreetLine1 = params.billingStreetLine1 || this.billingStreetLine1;
        this.billingCity = params.billingCity || this.billingCity;
        this.billingState = params.billingState || this.billingState;
        this.distributedDocumentsResponseModel = params.distributedDocumentsResponseModel || this.distributedDocumentsResponseModel;
        this.authorizationAgreementParams = params.authorizationAgreementParams || this.authorizationAgreementParams;
        this.isLifeOnlyAccount = params.isLifeOnlyAccount;
        this.setupPaymentResponse = params.setupPaymentResponse || this.setupPaymentResponse;
        this.hasVULCreditCardError = params.hasVULCreditCardError ?? this.hasVULCreditCardError;
        this.paymentPlan = params.paymentPlan || this.paymentPlan;
        this.errorDetails = params.errorDetails || this.errorDetails;
        if (params.wasRecurringAuthorizationFormSuccessfullySaved != null) {
            this.wasRecurringAuthorizationFormSuccessfullySaved = params.wasRecurringAuthorizationFormSuccessfullySaved;
        }
    }

    clear(): void {
        this.setUpAutomaticPaymentsForm = undefined;
        this.billingAccountHolderName = undefined;
        this.isEligibleForEasyPay = undefined;
        this.amountDue = undefined;
        this.currentBillDueDate = undefined;
        this.nextBillDueDate = undefined;
        this.considerThisDisplayable = undefined;
        this.emailAddress = undefined;
        this.selectedPayMethod = undefined;
        this.billingAccountNumber = undefined;
        this.successfullyEnrolled = undefined;
        this.billedStatus = undefined;
        this.billingStreetLine1 = undefined;
        this.billingCity = undefined;
        this.billingState = undefined;
        this.distributedDocumentsResponseModel = undefined;
        this.authorizationAgreementParams = undefined;
        this.isLifeOnlyAccount = undefined;
        this.emailAddress = undefined;
        this.hasVULCreditCardError = undefined;
        this.paymentPlan = undefined;
        this.errorDetails = undefined;
        this.wasRecurringAuthorizationFormSuccessfullySaved = false;
    }

    get flowInPlay(): boolean {
        return this.setUpAutomaticPaymentsForm !== undefined;
    }
}
